// Ovládání stránky Charts: hlavní metrika, sub graf, zóny RiskOn/RiskOff,
// porovnání v % s tickery (max 5). Graf se přestaví událostí `mx:rebuild`.
export function chartsControls(initialType, market) {
  return {
    type: initialType,
    sub: '',
    riskOff: true,
    riskOn: false,
    compare: false,
    range: '1y',
    tickers: {},
    symbol: '',
    error: '',
    loading: false,

    get tickerList() { return Object.keys(this.tickers); },

    rebuild() {
      const el = document.getElementById('charts-main');
      el?.dispatchEvent(new CustomEvent('mx:rebuild', { detail: {
        type: this.type, sub: this.sub, riskOff: this.riskOff, riskOn: this.riskOn,
        compare: this.compare, tickers: this.tickers, range: this.range,
      } }));
    },

    setType(t) {
      this.type = t;
      if (this.sub === t) this.sub = '';
      history.replaceState(null, '', `/${market}/charts/${t}/`);
      this.rebuild();
    },

    async addTicker() {
      const sym = this.symbol.trim().toUpperCase();
      this.error = '';
      if (!sym) return;
      if (this.tickers[sym]) { this.error = `${sym} is already shown.`; return; }
      if (this.tickerList.length >= 5) { this.error = 'You can compare up to 5 tickers.'; return; }
      this.loading = true;
      try {
        const res = await fetch(`/${market}/charts/ticker/?symbol=${encodeURIComponent(sym)}`, { credentials: 'same-origin' });
        if (!res.ok) { this.error = `${sym} was not found.`; return; }
        const body = await res.json();
        this.tickers = { ...this.tickers, [body.symbol]: body.data };
        this.compare = true;
        this.symbol = '';
        this.rebuild();
      } catch {
        this.error = 'Ticker data could not be loaded. Try again.';
      } finally {
        this.loading = false;
      }
    },

    removeTicker(sym) {
      const next = { ...this.tickers };
      delete next[sym];
      this.tickers = next;
      if (!this.tickerList.length) this.compare = false;
      this.rebuild();
    },
  };
}
